module.exports = __webpack_public_path__ + "img/search-property.0a6860d0.svg";